import { type FC } from "react";
import BasicLinkButton from "../baseLinkButton/BasicLinkButton";
import { PeopleType } from "features/Library/PeopleAssignments/types";
import { Icon } from "semantic-ui-react";
import { Tooltip } from "components/common/tooltip";

export interface EditPriorityLinkButtonProps {
  className?: string;
  onClick: () => void;
  isDisabled?: boolean;
  multiple?: boolean;
  peopleType?: PeopleType;
  showTooltip?: boolean;
}

const EditPriorityLinkButton: FC<EditPriorityLinkButtonProps> = ({
  className = "",
  onClick,
  isDisabled,
  multiple,
  peopleType,
  showTooltip,
}) => {
  const tooltip = showTooltip ? getTooltip(multiple, peopleType) : "";
  return (
    <Tooltip
      showAlways={tooltip}
      inverted
      hideOnScroll
      position={"bottom left"}
      target={
        <div style={{ display: "flex", alignItems: "center" }}>
          <BasicLinkButton
            className={className}
            iconClassName="fal fa-cog"
            text="Priority Settings"
            onClick={onClick}
            isDisabled={isDisabled}
          />
          {isDisabled && tooltip && <Icon className="fa fa-exclamation-circle" size="large" />}
        </div>
      }
      content={tooltip}
    />
  );
};

const getTooltip = (multiple: boolean | undefined, peopleType: PeopleType | undefined) => {
  if (peopleType === PeopleType.Group) {
    return multiple
      ? "At least one priority is set by Inherited Group or not assigned, and can't be changed."
      : "Priority is set by Inherited Group or not assigned, and can't be changed.";
  }
  return "";
};

export default EditPriorityLinkButton;
